export default "__VITE_ASSET__CVrX6IEu__"